import React from "react";
import { useTable } from "../../Components/useTable";

const ProfiletagsList = () => {
  const type = "Profile Tags";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "type", numeric: false, label: "Type" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default ProfiletagsList;
